const getters = {
  token: state => state.user.token,
  language: state => state.app.language
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js